export default __webpack_public_path__ + "static/media/user--0.248bc8ea.png";